/**
 * Free-port allocation for deploy targets.
 *
 * `connectors/src/port-pool.ts` exists but its `PortPool` is a stateful
 * range-allocator scoped to the connectors package; deploy targets just need a
 * single OS-assigned ephemeral port, so a small inline finder is the right fit.
 */

import { createServer } from "node:net";

/** Bind to port 0, read the OS-assigned port, release it, and return it. */
export function allocateFreePort(host = "127.0.0.1"): Promise<number> {
  return new Promise((resolve, reject) => {
    const server = createServer();
    server.once("error", reject);
    server.listen(0, host, () => {
      const addr = server.address();
      if (addr === null || typeof addr === "string") {
        server.close();
        reject(new Error("could not determine allocated port"));
        return;
      }
      const { port } = addr;
      server.close(() => resolve(port));
    });
  });
}
